import { memo } from 'react';
import AppBar from '../component/appBar/AppBar.component';
import Routes from "./Routes.container";
import { Container } from '../component/container/Container';
import ButtonHome from '../component/buttton/ButtonHome.component';
import GridComponent from '../component/grid/GridComponent.component';
import StoreProvider from '../context/Store';
import TaskProvider from '../context/Task'
import TaskExportBar from './task/components/taskExportBar/TaskExportBar.component';

function MenuC() {

    return (
        <StoreProvider>
            <TaskProvider>
                <TaskExportBar />
                <AppBar></AppBar>
                <GridComponent justify="flex-start" margin="8px 0px 0px 10px">
                    <ButtonHome />
                </GridComponent>
                <Container margin="10px 30px">
                    <Routes />
                </Container>
            </TaskProvider>
        </StoreProvider>
    );
}

export default memo(MenuC)
